export const EventosActionTypes = {
  API_RESPONSE_SUCCESS: '@@eventos/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@eventos/API_RESPONSE_ERROR',

  GET_EVENTO: '@@eventos/GET_EVENTO',
  LIST_EVENTOS: '@@eventos/LIST_EVENTOS',
  ADD_EVENTO: '@@eventos/ADD_EVENTO',
  UPDATE_EVENTO: '@@eventos/UPDATE_EVENTO',
  DELETE_EVENTO: '@@eventos/DELETE_EVENTO',
  SET_FILTER: '@@eventos/SET_FILTER',

  RESET: '@@eventos/RESET'
}
